import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  z-index: 1;
  margin: auto;
  width: 50rem;
  border-radius: 1vw;
  padding: 1.5rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  &:hover{
    background-color: #F4F4F4;
  }
`

export const InfosContainer = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1.2rem;
  list-style: none;
  margin-top: 1.4rem;
  padding: 0;
`

export const RowDatas = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr;
  span{
    font-weight: 700;
    display: flex;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 2rem;
`

export const ButtonDiv = styled.div`
  background-color: #0090D3;
  color: #fff;
  padding: 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:.5rem;
  border-radius: 2rem;
  user-select: none;
  cursor: pointer;
  img{
    width: 1rem;
  }
`